export const i18nDE = {
    igx_grid_groupByArea_message: 'Ziehe eine Spaltenüberschrift hierher, um danach zu gruppieren.',
    igx_grid_emptyFilteredGrid_message: 'Keine Einträge vorhanden.',
    igx_grid_emptyGrid_message: 'Keine Einträge vorhanden.',
    igx_grid_filter: 'Filter',
    igx_grid_filter_row_close: 'Schließen',
    igx_grid_filter_row_reset: 'Zurücksetzen',
    igx_grid_filter_row_placeholder: 'Filter hinzufügen',
    igx_grid_filter_row_boolean_placeholder: 'Alle',
    igx_grid_filter_row_date_placeholder: 'Datum auswählen',
    igx_grid_filter_operator_and: 'Und',
    igx_grid_filter_operator_or: 'Oder',
    igx_grid_complex_filter: 'Komplexer Filter',
    igx_grid_filter_contains: 'Enthält',
    igx_grid_filter_doesNotContain: 'Enthält nicht',
    igx_grid_filter_startsWith: 'Beginnt mit',
    igx_grid_filter_endsWith: 'Endet mit',
    igx_grid_filter_equals: 'Gleich',
    igx_grid_filter_doesNotEqual: 'Ungleich',
    igx_grid_filter_empty: 'Leer',
    igx_grid_filter_notEmpty: 'Nicht leer',
    igx_grid_filter_null: 'Null',
    igx_grid_filter_notNull: 'Nicht Null',
    igx_grid_filter_before: 'Davor',
    igx_grid_filter_after: 'Danach',
    igx_grid_filter_today: 'Heute',
    igx_grid_filter_yesterday: 'Gestern',
    igx_grid_filter_thisMonth: 'Dieser Monat',
    igx_grid_filter_lastMonth: 'Letzter Monat',
    igx_grid_filter_nextMonth: 'Nächster Monat',
    igx_grid_filter_thisYear: 'Dieses Jahr',
    igx_grid_filter_lastYear: 'Letztes Jahr',
    igx_grid_filter_nextYear: 'Nächstes Jahr',
    igx_grid_filter_greaterThan: 'Größer',
    igx_grid_filter_lessThan: 'Kleiner',
    igx_grid_filter_greaterThanOrEqualTo: 'Größer-Gleich',
    igx_grid_filter_lessThanOrEqualTo: 'Kleiner-Gleich',
    igx_grid_filter_true: 'Ja',
    igx_grid_filter_false: 'Nein',
    igx_grid_filter_all: 'Alle',
    igx_grid_filter_condition_placeholder: 'Filter auswählen',
    igx_grid_summary_count: 'Anzahl',
    igx_grid_summary_min: 'Min',
    igx_grid_summary_max: 'Max',
    igx_grid_summary_sum: 'Σ',
    igx_grid_summary_average: 'Ø',
    igx_grid_summary_earliest: 'Erster',
    igx_grid_summary_latest: 'Letzter',
    igx_grid_excel_filter_moving_left: 'nach links',
    igx_grid_excel_filter_moving_left_short: 'links',
    igx_grid_excel_filter_moving_right: 'nach rechts',
    igx_grid_excel_filter_moving_right_short: 'rechts',
    igx_grid_excel_filter_moving_header: 'verschieben',
    igx_grid_excel_filter_sorting_asc: 'aufsteigend',
    igx_grid_excel_filter_sorting_asc_short: 'auf',
    igx_grid_excel_filter_sorting_desc: 'absteigend',
    igx_grid_excel_filter_sorting_desc_short: 'ab',
    igx_grid_excel_filter_sorting_header: 'sortieren',
    igx_grid_excel_filter_clear: 'Spaltenfilter löschen',
    igx_grid_excel_custom_dialog_add: 'Filter hinzufügen',
    igx_grid_excel_custom_dialog_clear: 'Filter löschen',
    igx_grid_excel_custom_dialog_header: 'Eigener Auto-Filter in Spalte: ',
    igx_grid_excel_cancel: 'Abbrechen',
    igx_grid_excel_apply: 'Anwenden',
    igx_grid_excel_search_placeholder: 'Suchen',
    igx_grid_excel_select_all: 'Alle Auswählen',
    igx_grid_excel_blanks: '(Leer)',
    igx_grid_excel_hide: 'Spalte ausblenden',
    igx_grid_excel_pin: 'Spalte fixieren',
    igx_grid_excel_unpin: 'Spalte lösen',
    igx_grid_excel_text_filter: 'Textfilter',
    igx_grid_excel_number_filter: 'Zahlenfilter',
    igx_grid_excel_date_filter: 'Datumsfilter',
    igx_grid_excel_boolean_filter: 'Ja/Nein-Filter',
    igx_grid_excel_custom_filter: 'Eigener Filter...',
    igx_grid_paginator_label: 'Einträge pro Seite',
    igx_grid_advanced_filter_title: 'Erweitertes Filtern',
    igx_grid_advanced_filter_and_group: '\"Und\" Gruppe',
    igx_grid_advanced_filter_or_group: '\"Oder\" Gruppe',
    igx_grid_advanced_filter_end_group: 'Gruppenende',
    igx_grid_advanced_filter_create_and_group: '\"Und\" Gruppe erstellen',
    igx_grid_advanced_filter_create_or_group: '\"Oder\" Gruppe erstellen',
    igx_grid_advanced_filter_and_label: 'und',
    igx_grid_advanced_filter_or_label: 'oder',
    igx_grid_advanced_filter_add_condition: 'Bedingung',
    igx_grid_advanced_filter_ungroup: 'Gruppierung aufheben',
    igx_grid_advanced_filter_delete: 'Löschen',
    igx_grid_advanced_filter_delete_filters: 'Filter löschen',
    igx_grid_advanced_filter_initial_text: 'Beginne mit dem Erstellen einer Gruppe von Bedingungen, gekoppelt mit \"Und\" und \"Oder\"',
    igx_grid_advanced_filter_column_placeholder: 'Spalte auswählen',
    igx_grid_advanced_filter_value_placeholder: 'Wert',
    igx_time_picker_ok: 'OK',
    igx_time_picker_cancel: 'Abbrechen'
};
